import {isEmptyContent} from 'views/SlateEditor/functions'

export const isRawContentEmpty = (string) => {
  try {
    return isEmptyContent(string)
  } catch (error) {
    return true
  }
}
